@if (
    feeConfig.feeConfigs.entryFeeInfo?.unpaidAmountWithVat &&
    feeConfig.feeConfigs.regularEntryFeeConfig.entryFeeType !== EFeeType.PROPORTIONAL
) {
    <div class="fee-container" data-cy="regular-deposit-fee-info">
        <div class="fee-layout">
            <svg-icon
                src="assets/icons/money-bank.svg"
                class="fee-icon"
            ></svg-icon>
            <div class="info-wrapper">
                <div class="header">
                    {{ 'moneyAndTransactions.oneTimeFee' | translate }}
                </div>
                <div class="desc">
                    {{ 'moneyAndTransactions.oneTimeDescPart1' | translate }}
                  <b>{{ 'moneyAndTransactions.oneTimeDescBold' | translate }}</b>{{ 'moneyAndTransactions.oneTimeDescPart2' | translate }}
                </div>

                @let entryfeeConfig = feeConfig.feeConfigs.regularEntryFeeConfig;
                @if (entryfeeConfig) {
                    <div class="fee-row">
                        <div class="fee-label">
                            {{ 'moneyAndTransactions.totalEntryFeeVariant' | translate }}
                        </div>
                        <div class="fee-value">
                            <div class="value-wrapper">
                                @if (feeConfig.feeConfigs.entryFeeInfo && feeConfig.feeConfigs.entryFeeInfo!.totalEntryFee > 0) {
                                    <liberro-fee-info-tooltip [feeType]="entryfeeConfig.entryFeeType"></liberro-fee-info-tooltip>
                                }
                                {{ 'moneyAndTransactions.feeTypes.' + entryfeeConfig.entryFeeType | translate }}
                            </div>
                        </div>
                    </div>
                }
                <div class="fee-row" data-cy="entry-fee-total-row">
                    <div class="fee-label" data-cy="entry-fee-total-label">
                        {{ 'moneyAndTransactions.totalEntryFeeAmount' | translate }}
                    </div>
                    <div class="fee-value fee-value-inline">
                        <div class="value-wrapper" data-cy="entry-fee-total-amount">
                            <svg-icon
                                src="assets/icons/bwm-question-circle.svg"
                                class="question-mark-tooltip question-mark-cursor"
                                nz-tooltip
                                autoCloseOnScroll
                                mobileExplainTooltipSheet
                                [nzTooltipTitle]="totalEntryFeeAmountTooltip"
                                [nzTooltipVisible]="tooltipVisible()"
                                (nzTooltipVisibleChange)="tooltipToggle($event)"
                                (click)="tooltipToggle(!tooltipVisible())"
                                nzTooltipOverlayClassName="basic"
                                [svgStyle]="{ 'height.px':16 }"
                            ></svg-icon>
                            <ng-template #totalEntryFeeAmountTooltip>
                                <liberro-tooltip-content (closeClick)="onTooltipHide($event)">
                                    <div tooltipHeader>
                                        <div class="tooltip-header">
                                            {{ 'moneyAndTransactions.entryFee' | translate }}
                                        </div>
                                    </div>
                                    <div tooltipContent>
                                        <div class="tooltip-desc">
                                            {{ 'moneyAndTransactions.totalEntryFeeAmountTooltip' | translate }}
                                        </div>
                                    </div>
                                </liberro-tooltip-content>
                            </ng-template>

                            {{ feeConfig.feeConfigs.entryFeeInfo?.totalEntryFee ?? 0 | price:'CZK' }}
                        </div>
                         @if (entryfeeConfig?.entryDiscountRegular) {
                            <div class="fee-discount" data-cy="entry-fee-discount">
                                {{ 'moneyAndTransactions.includingSalePart1' | translate }}
                                {{ entryfeeConfig.entryDiscountRegular * 100 | number:'1.0-2' }} %
                                {{ 'moneyAndTransactions.includingSalePart2' | translate }}
                            </div>
                         }
                    </div>
                </div>
                <div class="fee-row">
                    <div class="fee-label">
                        {{ 'moneyAndTransactions.alreadyPaid' | translate }}
                    </div>
                    <div class="fee-value">
                        {{ (feeConfig.feeConfigs.hasVat ? feeConfig.feeConfigs.entryFeeInfo?.entryFeeAlreadyPaidWithVat : feeConfig.feeConfigs.entryFeeInfo?.entryFeeAlreadyPaid) ?? 0 | price:'CZK' }}
                        @if (feeConfig.feeConfigs.entryFeeInfo?.vatAlreadyPaid) {
                            <div class="fee-discount">
                                {{ 'moneyAndTransactions.alreadyPaidVATPart1' | translate }}
                                {{ feeConfig.feeConfigs.entryFeeInfo?.entryFeeAlreadyPaid ?? 0 | price:'CZK' }}
                                {{ 'moneyAndTransactions.alreadyPaidVATPart2' | translate }}
                                {{ feeConfig.feeConfigs.entryFeeInfo?.vatAlreadyPaid ?? 0 | price:'CZK' }}
                                {{ 'moneyAndTransactions.alreadyPaidVATPart3' | translate }}
                            </div>
                         }
                    </div>
                </div>
                <div class="fee-row">
                    <div class="fee-label">
                        @if (feeConfig.feeConfigs.hasVat) {
                            {{ 'moneyAndTransactions.unpaidWithVat' | translate }}
                        } @else {
                            {{ 'moneyAndTransactions.unpaidWithoutVat' | translate }}
                        }
                    </div>
                    <div class="fee-value">
                        {{ feeConfig.feeConfigs.entryFeeInfo?.unpaidAmountWithVat ?? 0 | price:'CZK' }}
                    </div>
                </div>
            </div>
        </div>
    </div>
}
